import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from 'react-router-dom';
import Box from "@mui/material/Box";
import {estimateStatuses} from "../../../../../../data/EstimateState";
import EstimateService from "../../../../../../API/orders/estimate/organization/EstimateService";
import {estimateTableParams} from "../../../../../../data/EstimateTableParams";
import ButtonText from "../../../../button/ButtonText";
import ButtonCreate from "../../../../button/ButtonCreate";
import {estimateTableData} from "../../../../../../utils/orders/EstimateTableData";
import ModalConfirm from "../../../../modal/ModalConfirm";
import {Checkbox, Tooltip} from "@mui/material";
import EditEstimateModal from "./EditEstimateModal";
import FormControlLabel from "@mui/material/FormControlLabel";

const EstimateTable = ({
                           data,
                           setData,
                           orderId,
                           orderNumber,
                           orderHeaderId,
                           year,
                           currentCurrency,
                           handleModalAlert,
                           setInWorkModalOpen
                       }) => {
    const tableData = estimateTableData(currentCurrency, data)
    const [modalEdit, setModalEdit] = useState(false);

    const navigate = useNavigate();
    const redirectEstimateItem = () => {
        navigate('/organization/orders/' + orderId + '/' + encodeURIComponent(orderNumber) + '/' + orderHeaderId + '/' + year + '/estimate/' + data[0]?.id + "/" + data[0]?.estimateState);
    };

    const handleUpdate = () => {
        setModalEdit(true)
    };


    const handleSubmitEditData = (data) => {
        const {id, ...value} = data
        EstimateService.save(id, value)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === id ? response.data : el))
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
        setModalEdit(false)
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'param',
                header: `Параметр`,
                accessorKey: "param",
                Cell: ({cell}) => estimateTableParams[cell.getValue()],
                minSize: 15,
                maxSize: 15,

            },
            {
                id: 'plan',
                header: `План`,
                accessorKey: "plan",
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const prev = cell.getValue()?.prevPrice !== null
                    const value = row.original.param === "STATE" || row.original.param === "GROSSMARGIN" ? cell.getValue() : cell.getValue()?.price;

                    const isCostPrice = row.original.param === "COST" || row.original.param === "JOBCOST"
                    const total = currentCurrency === 1 ? data[0]?.calculationTotalCostBasePrice?.price : data[0]?.calculationTotalCostAlternativePrice?.price
                    const percent = isCostPrice && value ? `(${(value / total * 100).toFixed(2)}%)` : ""

                    return <Tooltip arrow placement="left"
                                    title={prev ? `Предыдущие значение ${cell.getValue()?.prevPrice?.toFixed(2)}` : ""}>
                        <Box> {row.original.param === "STATE" ? estimateStatuses[value] : row.original.param === "JOB" || row.original.param === "PRICE" || row.original.param === "SALES" ? "" : value === null || value === undefined ? 'Ожидание' : value.toFixed(2)}
                            <span style={{color: "#3B8BEC", paddingLeft: "5px"}}>{percent}</span>
                        </Box>
                    </Tooltip>
                },

            }, {
                id: 'fact',
                header: `Фактическая`,
                accessorKey: "fact",
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const prev = cell.getValue()?.prevPrice
                    const value = row.original.param === "STATE" || row.original.param === "GROSSMARGIN" ? cell.getValue() : cell.getValue()?.price;
                    const handPrice = cell.getValue()?.handPrice

                    const isCostPrice = row.original.param === "COST" || row.original.param === "JOBCOST"
                    const isTotalPrice = row.original.param === "PRICE" || row.original.param === "JOB"
                    const total = currentCurrency === 1 ? (isCostPrice ? data[0]?.totalCostBasePrice?.price : data[0]?.baseTotalPrice?.price) : (isCostPrice ? data[0]?.totalCostAlternativePrice?.price : data[0]?.alternativeTotalPrice?.price)
                    const percent = (isCostPrice || isTotalPrice) && value ? `(${(value / total * 100).toFixed(2)}%)` : ""

                    return <Tooltip
                        arrow placement="left"
                        title={prev ?
                            <Box>{`Предыдущие значение ${cell.getValue()?.prevPrice?.toFixed(2)}`}<br/>{`Количество вводов цены ${cell.getValue()?.numberManual}`}
                            </Box>
                            : ""}>
                        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            <Box> {row.original.param === "STATE" ? "" : value === null || value === undefined ? 'Ожидание' : value.toFixed(2)}
                                <span style={{color: "#3B8BEC", paddingLeft: "5px"}}>{percent}</span>
                            </Box>
                            {["COST", "JOBCOST", "PRICE", "JOB"].includes(row.original.param) &&
                                <FormControlLabel
                                    control={<Checkbox
                                        disabled={true}
                                        checked={handPrice}
                                    />}
                                    label="Ручная цена"
                                />}
                        </Box>
                    </Tooltip>
                },
            }
        ];

        return baseColumns;

    }, [data, currentCurrency]);

    return (
        <Box sx={{
            display: "flex",
            gap: "24px",
            flexDirection: "column",
            width: "700px",
            padding: "24px",
            borderRadius: "16px",
            border: (theme) => `${theme.palette.primary.stroke} 1px solid`
        }}>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTablePaperProps={{
                    sx: {
                        boxShadow: "none"
                    }
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        color: "rgba(115, 116, 120, 1)",
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem",
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}
                columns={columns}
                data={tableData}
                enableRowSelection={false}
                enableKeyboardShortcuts={false}
                enableColumnActions={false}
                enableColumnFilters={false}
                enablePagination={false}
                enableSorting={false}
                getRowId={(originalRow) => originalRow.id}
                selectionPadding={1}
                selectionCss={{
                    backgroundColor: 'lightblue',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'blue',
                    borderRadius: '4px',
                }}
                localization={MRT_Localization_RU}
                enableTopToolbar={false}
                enableRowActions={false}
                enableToolbarInternalActions={false}
                enableTableFooter={false}
                enableBottomToolbar={false}
                enableStickyFooter={false}
                muiTableContainerProps={{
                    sx: {
                        width: "746px"
                    }
                }}
            />
            <Box sx={{display: "flex", gap: "24px"}}>
                <ButtonText text={"Подробнее"} blue={true} onClick={() => redirectEstimateItem()}/>
                <ButtonCreate
                    text={"Изменить"}
                    width={90}
                    icon={false}
                    disabled={currentCurrency === 2}
                    onClick={handleUpdate}
                />
                <ButtonCreate
                    text={"Отправить в работу"}
                    width={170}
                    icon={false}
                    onClick={() => setInWorkModalOpen(true)}
                    disabled={data[0]?.estimateState !== 'CALCULATION'}
                />
            </Box>

            {modalEdit && <EditEstimateModal
                open={modalEdit}
                onClose={() => setModalEdit(false)}
                onSubmit={handleSubmitEditData}
                initFormState={data[0]}/>}
        </Box>
    );
};

export default EstimateTable;